module.exports = __webpack_public_path__ + "img/case2.ed44e2f0.png";